require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/daniloradovic/Desktop/coinis/webb-holding/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/daniloradovic/Desktop/coinis/webb-holding/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/daniloradovic/Desktop/coinis/webb-holding/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/daniloradovic/Desktop/coinis/webb-holding/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/daniloradovic/Desktop/coinis/webb-holding/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/daniloradovic/Desktop/coinis/webb-holding/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./projects.js") })
        }
      }, "component---src-pages-projects-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---src-pages-projects-js!./src/pages/projects.js
// module id = 332
// module chunks = 231608221292675